import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WithdrawalService } from '../../_core/_services/withdrawal.service';
import { NotificationService } from '../../_core/_services/notification.service';
import { WithdrawalBeneficiaryDto } from '../../_core/_model/withdrawal';
import { prettifyFieldKey, maskSensitiveValue } from '../../_core/_helpers/withdrawal-field.helper';

@Component({
  selector: 'app-user-withdrawal-beneficiaries',
  standalone: false,
  templateUrl: './withdrawal-beneficiaries.html',
  styleUrl: './withdrawal-beneficiaries.css'
})
export class UserWithdrawalBeneficiaries implements OnInit {
  walletId = '';
  loading = false;
  togglingId = '';

  items: WithdrawalBeneficiaryDto[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private withdrawalService: WithdrawalService,
    private notifyService: NotificationService
  ) { }

  ngOnInit(): void {
    this.walletId = this.route.snapshot.paramMap.get('walletId') || '';
    if (!this.walletId) {
      this.notifyService.showError('Wallet ID is missing.', 'Error');
      this.router.navigate(['/wallets']);
      return;
    }

    this.loadItems();
  }

  loadItems(): void {
    this.loading = true;

    this.withdrawalService.getBeneficiaries(this.walletId).subscribe({
      next: (res) => {
        this.items = res.data || [];
      },
      error: (err) => {
        this.notifyService.showError(
          err?.error?.Error?.Details || err?.error?.message || 'Failed to load beneficiaries.',
          'Error'
        );
        this.items = [];
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  toggleStatus(item: WithdrawalBeneficiaryDto): void {
    if (this.togglingId) return;

    this.togglingId = item.id;

    this.withdrawalService.toggleBeneficiaryStatus(item.id).subscribe({
      next: () => {
        this.notifyService.showSuccess(
          item.isActive ? 'Beneficiary deactivated.' : 'Beneficiary reactivated.',
          'Success'
        );
        this.loadItems();
      },
      error: (err) => {
        this.notifyService.showError(
          err?.error?.Error?.Details || err?.error?.message || 'Failed to update beneficiary.',
          'Error'
        );
      },
      complete: () => {
        this.togglingId = '';
      }
    });
  }

  useBeneficiary(item: WithdrawalBeneficiaryDto): void {
    if (!item.isActive) {
      this.notifyService.showError(
        'This beneficiary is inactive.',
        'Beneficiary'
      );
      return;
    }

    sessionStorage.setItem(
      'selected_withdrawal_beneficiary',
      JSON.stringify(item)
    );

    this.router.navigate([
      '/wallets/withdraw',
      this.walletId
    ]);
  }

  destinationEntries(json: string): { key: string; label: string; value: any }[] {
    if (!json) return [];

    try {
      const parsed = JSON.parse(json);
      return Object.entries(parsed).map(([key, value]) => ({
        key,
        label: prettifyFieldKey(key),
        value: maskSensitiveValue(key, value)
      }));
    } catch {
      return [];
    }
  }

  badgeClass(active: boolean): string {
    return active ? 'text-bg-success' : 'text-bg-secondary';
  }

  back(): void {
    this.router.navigate(['/wallets/withdraw', this.walletId]);
  }
}